// Import translation
import i18n from 'i18next';

export const select_passes_types = [
	{
		name: i18n.t('passes:types.pass'),
		value: 'pass'
	}
];
